// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__6g5nA","logo":"styles_logo__gJ+eD","navigation":"styles_navigation__R7WOj","society":"styles_society__0vH40"};